import React from 'react';
import {EdgeProps} from 'reactflow';

import maybeEllipsizeLabel, {
  EDGE_LABEL_MAX_LENGTH,
} from 'processes/graph-builder-processes/flowchart-viz/util/maybeEllipsizeLabel';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';

type EdgeLabelProps = Pick<
  EdgeProps,
  'label' | 'labelStyle' | 'labelBgBorderRadius' | 'labelBgStyle' | 'labelShowBg' | 'labelBgPadding'
> & {
  labelX: number;
  labelY: number;
};

export default function EdgeLabel(props: EdgeLabelProps): JSX.Element {
  return (
    <div
      style={{
        padding: props.labelBgPadding?.map((padding) => `${padding}px`).join(' '),
        borderRadius: props.labelBgBorderRadius,
        ...props.labelBgStyle,
        // Manually set the edge position and z-index to ensure that the label is in the middle of the
        // edge and will not be "underneath" any overlapping edges.
        zIndex: 3,
        position: 'absolute',
        transform: `translate(-50%, -50%) translate(${props.labelX}px,${props.labelY}px)`,
        pointerEvents: 'all',
        cursor: 'pointer',
      }}
      className="nopan"
    >
      <span style={props.labelStyle}>
        {typeof props.label === 'string' && props.label.length > EDGE_LABEL_MAX_LENGTH ? (
          <Popover renderContent={() => props.label} placement={FloatingPlacement.BOTTOM}>
            <span>{maybeEllipsizeLabel(props.label)}</span>
          </Popover>
        ) : (
          props.label
        )}
      </span>
    </div>
  );
}
